import React from 'react'
// import { FormattedMessage } from 'react-intl'
import messages from './messages'
import classes from './styles.module.scss'
import { createForm } from 'rc-form'
import { Flex, WhiteSpace, WingBlank } from 'antd-mobile'
import { Helmet } from 'react-helmet'
import { intl, getCurrentLanguage, setHtmlLangAndDir } from 'utils'
import queryString from 'query-string'
import Div100vh from 'react-div-100vh'
import { Markdown } from 'components'

const faqs = {
  referral: {
    en: require('markdown/en/PayBy Referral Campaign Rules.md'),
    ar: require('markdown/ar/PayBy Referral Campaign Rules.md')
  },
  mobile_top_up: {
    en: require('markdown/en/PayBy Top-up Day Campaign Rules.md'),
    ar: require('markdown/en/PayBy Top-up Day Campaign Rules.md')
  },
  seasonal_offer: {
    en: require('markdown/en/PayBy Seasonal Offer Campaign Rules.md'),
    ar: require('markdown/en/PayBy Seasonal Offer Campaign Rules.md')
  },
  member_share: {
    en: require('markdown/en/PayBy Member Share Terms and Conditions.md'),
    ar: require('markdown/en/PayBy Member Share Terms and Conditions.md')
  },
  terms_and_conditions: {
    en: require('markdown/en/PayBy Campaign Terms and Conditions.md'),
    ar: require('markdown/en/PayBy Campaign Terms and Conditions.md')
  },
  unionpay: {
    en: require('markdown/en/PayBy UnionPay Cards Campaign Rules.md'),
    ar: require('markdown/en/PayBy UnionPay Cards Campaign Rules.md')
  }
}
class Rules extends React.Component {
  constructor(props) {
    super(props)
    const params = queryString.parse(location.search)
    this.state = {
      campaign: params.campaign || 'referral',
      language: getCurrentLanguage()
    }
    const { campaign, language } = this.state
    campaign === 'referral' && setHtmlLangAndDir(language)
  }

  render() {
    const { form } = this.props
    console.log(form)
    const { campaign, language } = this.state
    return (
      <Div100vh>
        <Helmet>
          <title>
            {campaign === 'unionpay'
              ? 'Terms and conditions'
              : intl.formatMessage(messages.title)}
          </title>
        </Helmet>
        <Flex.Item className={classes.festivalRules}>
          <WhiteSpace size='lg' />
          <WingBlank>
            {faqs[campaign] ? (
              <Markdown source={faqs[campaign][language].default} />
            ) : (
              <React.Fragment>
                <p className='text-center'>
                  <b>Campaign Rules</b>
                </p>
                <WhiteSpace size='xl' />
                {campaign === 'get-5-dirham-every-week' && (
                  <React.Fragment>
                    <ol>
                      <li>
                        All of the existing users can receive an AED 5 discount voucher
                        every week during the campaign.
                      </li>
                      <li>Do note that the voucher is valid only for 7 days.</li>
                      <li>
                        To redeem, it can be used in all merchants supported by PayBy.
                      </li>
                      <li>
                        All vouchers cannot be used in conjunction with any other offers
                        and discounts of PayBy.
                      </li>
                      <li>Each EID can get one AED 5 voucher a week.</li>
                      <li>All rights reserved.</li>
                    </ol>
                  </React.Fragment>
                )}
                {campaign === 'commission_basic_inviter' && (
                  <React.Fragment>
                    <p>Promo Time：Jan 2 - Jan 15, 2022</p>
                    <WhiteSpace />
                    <p>
                      <strong>Need to know.</strong>
                    </p>
                    <WhiteSpace />
                    <p>
                      <strong>
                        1.The Promo is open to all users who already registered and newly
                        registered PayBy accounts.
                      </strong>
                    </p>
                    <WhiteSpace />
                    <ol>
                      <li>
                        During the campaign, AED 10 cash bonus and an AED 5 voucher will
                        be given to your PayBy account when a referral is successful(a
                        friend register and activate PayBy account with EID.)
                      </li>
                      <li>
                        To redeem, the AED 5 voucher can be used in all merchants
                        supported by PayBy online and in-store.
                      </li>
                      <li>
                        All vouchers cannot be used in conjunction with any other offers
                        and discounts of PayBy.
                      </li>
                      <li>Do note that the voucher is valid only for 7 days.</li>
                    </ol>
                    <WhiteSpace />
                    <p>
                      <strong>2.All invitees should be new users.</strong>
                    </p>
                    <WhiteSpace />
                    <ol>
                      <li>
                        a new user must apply for a totally new account of PayBy. i.e. a
                        totally new relationship with PayBy, not have activated PayBy
                        account with the same EID before, not have an existing account, or
                        have had any account on PayBy before.
                      </li>
                    </ol>
                    <p>
                      <strong>3.About the cash bonus.</strong>
                    </p>
                    <WhiteSpace />
                    <ol>
                      <li>
                        There is no up limit to the cash bonus. In principle, the more you
                        refer, the more you earn.
                      </li>
                      <li>
                        Each EID only has one chance to participate. And cannot receive
                        the cash bonus again on other PayBy accounts with the same
                        identity(EID).
                      </li>
                      <li>
                        For users without bank cards like college students, the cash bonus
                        can be used in Taxi, Mobile Top-up, and Supermarkets like Lulu, Al
                        Maya, and Al AIN CO-OP.etc. And it is also valid for Thumbay Food
                        Court and Blends blews.
                      </li>
                      <li>
                        All the cash bonus will be sent to your PayBy account, you can
                        withdraw it to your bank account or transfer it to others who have
                        a PayBy account.
                      </li>
                    </ol>
                    <WhiteSpace />
                    <p>
                      <strong>4.Other terms and conditions</strong>
                    </p>
                    <WhiteSpace />
                    <ol>
                      <li>
                        All users MUST have met all our identification and verification
                        requirements and satisfy to PayBy’s internal policies.
                      </li>
                      <li>
                        Any cheating or violation of these terms and conditions by users
                        shall result in being disqualified. PayBy reserves the right to
                        suspend or cancel any Promo and the redeeming of the cash bonus.
                      </li>
                      <li>All Rights Reserved.</li>
                    </ol>
                  </React.Fragment>
                )}
                {campaign === 'commission_basic_invitee' && (
                  <React.Fragment>
                    <p>Promo Time：Jan 2 - Jan 15, 2022</p>
                    <WhiteSpace />
                    <p>
                      <strong>Need to know.</strong>
                    </p>
                    <WhiteSpace />
                    <p>
                      1.If you are referred by others, you should enter your referral code
                      and complete your ID verification, then you will get AED 5 cash
                      reward.
                    </p>
                    <WhiteSpace />
                    <p>
                      2.To get AED 5 cash, you’d better download PayBy App or find in
                      ToToK tap“Discover”-“PayBy” or in BOTIM tap “Explore”-“PayBy” and
                      complete personal profile.
                    </p>
                    <WhiteSpace />
                    <p>
                      3.Each EID only has one chance to participate. And cannot receive
                      the cash bonus again on other PayBy accounts with the same
                      identity(EID).
                    </p>
                    <WhiteSpace />
                    <p>
                      4.All the cash bonus will be sent to your PayBy account, you can
                      withdraw it to your bank account or transfer it to others who have a
                      PayBy account.
                    </p>
                    <WhiteSpace />
                    <p>
                      5.For users without bank cards like college students, the cash bonus
                      can be used in Taxi, Mobile Top-up, and Supermarkets like Lulu, Al
                      Maya, and Al AIN CO-OP.etc. And it is also valid for Thumbay Food
                      Court and Blends blews.
                    </p>
                    <WhiteSpace />
                    <p>6.Other terms and conditions.</p>
                    <WhiteSpace />
                    <ol>
                      <li>
                        All users MUST have met all our identification and verification
                        requirements and satisfy to PayBy’s internal policies.
                      </li>
                      <li>
                        Any cheating or violation of these terms and conditions by users
                        shall result in being disqualified. PayBy reserves the right to
                        suspend or cancel any Promo and the redeeming of the cash bonus.
                      </li>
                      <li>All Rights Reserved.</li>
                    </ol>
                  </React.Fragment>
                )}
              </React.Fragment>
            )}
          </WingBlank>
        </Flex.Item>
      </Div100vh>
    )
  }
}

export default createForm()(Rules)
